import { atom } from 'recoil';

export interface IDrawerState {
  contentDrawer: boolean;
  notesDrawer: boolean;
}

export const drawerPdfAtom = atom<IDrawerState>({
  key: 'drawerPdfAtom',
  default: {
    contentDrawer: false,
    notesDrawer: false,
  },
});
